/** How much navbar a scene shows: the full one, or only a way out. */
export const NAVBAR_TYPES = {
  standard: 'standard',
  minimal: 'minimal',
} as const

export type NavbarType = (typeof NAVBAR_TYPES)[keyof typeof NAVBAR_TYPES]

/** Where the minimal navbar's link goes. */
export const NAVBAR_ACTIONS = {
  home: 'home',
  back: 'back',
} as const

export type NavbarAction = (typeof NAVBAR_ACTIONS)[keyof typeof NAVBAR_ACTIONS]
